import { Modal, Text } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useLogout } from '../_hooks/logout';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const LogoutModal: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { mutateAsync } = useLogout();
  const navigate = useNavigate();
  return (
    <Modal
      title={t('confirm-logout')}
      open={open}
      onOk={async () => {
        await mutateAsync();
        onClose();
        navigate('/');
      }}
      onCancel={() => {
        onClose();
      }}
      okText={t('logout')}
      cancelText={t('cancel')}
    >
      <Text text={t('confirm-logout-message')} />
    </Modal>
  );
};
